import styled from "styled-components";
import { colors, screenSizes, typography } from "@streeteasy/design-system";
import ButtonAction, {
  buttonActionThemes
} from "@streeteasy/design-system/button-action";

import { calendarIcon, chevronIcon } from "../../assets";

export const Wrapper = styled.div`
  border: 1px solid ${colors.GRAY_LIGHT};
  padding: 23px 0 0 15px;
  position: relative;
  width: 392px;

  @media screen and (max-width: ${screenSizes.LARGE_SCREEN}px) {
    width: 100%;
  }
`;

export const CalendarIcon = styled.img.attrs({
  alt: "open houses",
  "aria-hidden": true,
  src: calendarIcon
})`
  color: ${colors.BRAND};
  left: 15px;
  padding: 0;
  position: absolute;
  top: 30px;
`;

export const ChevronIcon = styled.img.attrs({
  "aria-hidden": true,
  src: chevronIcon
})`
  margin: 0 5px 0 0;
  padding: 0;
  transform: rotate(${props => (props.isExpanded ? "0" : "180deg")});
`;

export const ListWrapper = styled.div`
  margin: 0 0 0 41px;
`;

export const ListTitle = styled(typography.Caps)`
  color: ${colors.TEXT_SECONDARY};
`;

export const ExpandableSection = styled.div`
  [class*="styled__Wrapper"] {
    &:nth-child(2) {
      margin: -13px 0 0;
    }

    &:last-child {
      border-bottom: ${props =>
        props.isExpanded ? "none" : `1px solid ${colors.WHITE}`};
    }
  }
`;

export const ExpandButton = styled(ButtonAction).attrs({
  type: "button",
  theme: buttonActionThemes.SECONDARY
})`
  background: none;
  border: none;
  display: flex;
  align-items: center;
  height: auto;
  min-width: auto;
  padding: 0;

  &:focus {
    background: none;
    border: none;
  }
`;
